// lodash components
import forEach from 'lodash/forEach'

export default function loadComponents(app, store) {
    const files = require.context('../', true, /\.vue$/i)
    const filesToLoad = new Map()
    files.keys().map(key => {
        // search for territory directories and exclude territories that are not current to avoid duplicate named files
        let skip = false
        forEach(window.VALID_TERRITORIES, terr => {
            const isTerritorySpecific = key.search(`/${terr}/`) >= 0

            if (isTerritorySpecific) {
                if (terr !== window.TERRITORY) {
                    skip = true
                    return false
                }

                // check if non-territory version. Remove if so.
                const keyNonTerr = key.replace(`/${terr}/`, '/')
                filesToLoad.delete(keyNonTerr)
            }

            return true
        })

        if (!skip) {
            filesToLoad.set(key, files(key).default)

            if (key.startsWith('./components/apply-wizard/steps/')) {
                store.commit('addAvailableStep', files(key).default)
            }
        }
    })

    for (const [key, value] of filesToLoad) {
        app.component(key.split('/').pop().split('.')[0], value)
    }
}
